import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Chart, ChartTypeRegistry } from 'chart.js';
import { Router } from '@angular/router';
import { User } from 'src/app/micro-services/user/models/user';


@Component({
  selector: 'app-widget-finance',
  templateUrl: './widget-finance.component.html',
  styleUrls: ['./widget-finance.component.scss'],
})
export class WidgetFinanceComponent implements OnInit {

  @ViewChild('lineChart') private lineChart: ElementRef;
  lineChartX: Chart;

  //LineChart
  dataProfitEvolution: number[] = [];
  profitEvolutionLabel = "";
  profitEvolutionLabelTitle: string[] = [];
  optionsProfitEvolution: any = {};
  dataLoaded3: boolean = false;
  realData3: boolean = false;
  dataLine: any = {};

  //DATE
  now: Date = new Date()
  startDate: any = new Date(this.now.getFullYear() - 1, this.now.getMonth(), this.now.getDate())
  endDate: any = this.now

  coach: User;
  coachId: string

  constructor(
    private userService: UserService,
    private ApiProviderService: ApiProviderService,
    private zone: NgZone,
    private router : Router
  ) { }

  ngOnInit() {
    //Get the Coach
    this.coach = this.userService.getUser();
    if (this.coach) {
      this.coachId = this.coach.id;
    }
  }

  ngAfterViewInit(): void {
    //Chart First Creation
    this.zone.run(() => {
      this.getProfitEvolutionByCoach(this.startDate, this.endDate)
    });
  }

  //Line Chart
  getProfitEvolutionByCoach(startDate: Date, endDate: Date) {
    this.dataProfitEvolution = []
    this.profitEvolutionLabelTitle = []
    this.dataLine = []

    this.ApiProviderService.getProfitsByMonthByCoach(this.userService.getUser().id, startDate, endDate)
      .subscribe(
        (data: any) => {
          if (data) {
            data.forEach(element => {
              this.dataProfitEvolution.push(element.totalAmount);
              this.profitEvolutionLabelTitle.push(element.month)
            });

            this.dataLine = {
              labels: this.profitEvolutionLabelTitle,
              datasets: [{
                data: this.dataProfitEvolution,
                pointStyle : false,
                borderColor: '#0061c8',
                pointBackgroundColor: '#0061c8',
                pointHoverBackgroundColor: '#0061c8',
                borderWidth: 2, // main line width
                hoverBorderWidth: 0, // borders on points
                pointBorderWidth: 0, // removes POINT borders
                tension: 0.3, // makes line more squiggly
              }]
            }
            this.profitEvolutionLabel = "€ généré"
            this.optionsProfitEvolution = {
              scales: {
                x: {
                  border:{
                    display : false
                  },
                  ticks:{
                    display: false
                  },
                  grid: {
                    display: false,
                    drawTicks : false
                  },
                  
                },
                y: {
                  border:{
                    display : false
                  },
                  ticks: {
                    // Include a dollar sign in the ticks
                    callback: function (value, index, ticks) {
                      return value + '€';
                    }
                  },
                  grid: {
                    display: false,
                    drawTicks : false
                  },
                }
              },
              plugins: {
                responsive: true,
                legend: {
                  display: false,
                },
                tooltip: {
                  enabled :false,
                },
              },

              maintainAspectRatio: false
            }
          }
          this.dataLoaded3 = true;
          if (this.dataProfitEvolution.some(valeur => valeur !== 0)) {
            this.realData3 = true;
            this.createChart(this.lineChart, "line");
          }
        },
        (error) => {
          // Handle any errors that occurred during the API call
          console.error(error);
        }
      );
  }

  //Creation and Update Chart

  createChart(nativeElement: ElementRef, type: string) {
    if (type === "line") {
      setTimeout(() => {
        const ctx = this.lineChart.nativeElement;
        this.lineChartX = new Chart(ctx, {
          type: type,
          data: this.dataLine,
          options: this.optionsProfitEvolution,
        });
      }, 300);
    }
  }

  updateChart(chart: any) {
    if (chart == this.lineChartX) {
      this.lineChartX.destroy()
      setTimeout(() => {
        const ctx = this.lineChart.nativeElement;
        this.lineChartX = new Chart(ctx, {
          type: "line",
          data: this.dataLine,
          options: this.optionsProfitEvolution,
        });
      }, 100);
    }
  }

  goToDashboardFinance(){
    this.router.navigate(['/coach/dashboard-finance']);
  }
}
